import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Article } from '../../../model/Article';
import HttpClient, { Callback, CallbackType, ExtraAction } from '../api';
import { updatePaginatedArticles } from '../paginated-articles';

const INITIAL_STATE: Array<Article> = [];

const articlesSlice = createSlice({
  name: 'articles',
  initialState: INITIAL_STATE,
  reducers: {
    addArticle: (state, action: PayloadAction<Article>) => [...state, action.payload],
    updArticle: (state, action: PayloadAction<Article>) => {
      const articleIndex = state.findIndex((article) => article.id === action.payload.id);
      if (articleIndex !== -1) {
        state[articleIndex] = { ...state[articleIndex], ...action.payload };
      } else {
        throw new Error('Verify the updated article in the store because it wasn`t found');
      }
    },
    delArticle: (state, action: PayloadAction<Article>) => [...state, action.payload],
  },
});

export const { addArticle, updArticle, delArticle } = articlesSlice.actions;

export default articlesSlice.reducer;

export const findArticleFromCategory = (
  category: string,
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      full: false,
      function: () => console.log('findArticleByCategory by category success'),
    },
  ],
) => {
  return HttpClient.findArticleByCategory(
    category,
    addArticle.type,
    customErrorsMap,
    extraActions,
    callbacks,
  );
};

export const updateArticle = (article: Article, callbacks?: Array<Callback>) => {
  if (article.category.type.toUpperCase() === 'SINGLE') {
    return HttpClient.updateArticle(article, updArticle.type, callbacks);
  }
  return HttpClient.updateArticle(article, updatePaginatedArticles.type, callbacks);
};

export const createArticle = (article: Article, callbacks?: Array<Callback>) => {
  return HttpClient.createArticle(article, addArticle.type, callbacks);
};

export const deleteArticle = (articleId: number, callbacks?: Array<Callback>) => {
  return HttpClient.deleteArticle(articleId, delArticle.type, callbacks);
};
